import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';


import {FuseSharedModule} from '@fuse/shared.module';

import {Error404Component} from './error-404.component';
import {SharedModule} from '../../shared/shared.module';

const routes = [
  { path: '**', component: Error404Component }
];

@NgModule({
  declarations: [
    Error404Component
  ],
  imports: [
    // RouterModule.forChild(routes),

    FuseSharedModule,
    SharedModule,
  ],
})
export class Error404Module { }
